import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function AuthLoading({ label = '불러오는 중이에요...' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background-50">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-loader-4-line animate-spin text-2xl"></i>
      </span>
      <p className="text-sm font-medium text-foreground-600">{label}</p>
    </div>
  );
}

/** 로그인 + 운영자 승인까지 통과한 사용자만 접근 허용 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, profile, loading, profileLoading } = useAuth();
  const location = useLocation();

  if (loading) return <AuthLoading />;
  if (!session) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (profileLoading) return <AuthLoading label="회원 정보를 확인하는 중이에요..." />;
  if (!profile || profile.status !== 'approved') return <Navigate to="/pending" replace />;

  return <>{children}</>;
}

/** 운영자(관리자)만 접근 허용 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { session, profile, loading, profileLoading } = useAuth();

  if (loading) return <AuthLoading />;
  if (!session) return <Navigate to="/login" replace />;
  if (profileLoading) return <AuthLoading label="회원 정보를 확인하는 중이에요..." />;
  if (!profile || profile.status !== 'approved') return <Navigate to="/pending" replace />;
  if (profile.role !== 'admin') return <Navigate to="/" replace />;

  return <>{children}</>;
}